export function userAssignmentPayload (activity) {
  if (!activity || !activity.config || !activity.config.user_id || !activity.config.itemId) {
    throw new Error('missing required user assignment values')
  }

  return {
    user_id: activity.config.user_id,
    user_id_type: 'macmillan',
    assignment_id: activity.config.itemId
  }
}

export function getAPIendpointPrefix (activity) {
  return window.location.href.indexOf('/lcrp') > 0 ? '/' : ''
}
